import { CameraIcon, PhoneOffIcon, MicIcon, Volume2Icon, VolumeXIcon, MicOffIcon } from 'lucide-react'; // Replace 'lucide-react' with your actual icon library

const RemoteCallControls = ({ isMuted, isVolumeOff, handleToggleMic, handleToggleVolume, handleTakeScreenshot, endCall }: any) => {
    // Determine which mic/volume icon to show based on state
    const MicComponent = isMuted ? MicOffIcon : MicIcon;
    const VolumeComponent = isVolumeOff ? VolumeXIcon : Volume2Icon;

    return (
        <div
            className="absolute bottom-8 left-1/2 transform -translate-x-1/2 flex gap-6 z-10 items-center bg-black/50 rounded-xl py-3 px-6 shadow-2xl"
        >
            {/* 1. Mic On/Off Button */}
            <button
                onClick={handleToggleMic}
                className={`text-white hover:opacity-80 transition-all active:scale-95 drop-shadow-lg p-3 rounded-full ${isMuted ? 'bg-gray-600' : 'bg-transparent'}`}
                title={isMuted ? "Unmute Mic" : "Mute Mic"}
            >
                <div className="transform scale-125">
                    <MicComponent size={24} />
                </div>
            </button>

            {/* 2. Speaker On/Off Button */}
            <button
                onClick={handleToggleVolume}
                className={`text-white hover:opacity-80 transition-all active:scale-95 drop-shadow-lg p-3 rounded-full ${isVolumeOff ? 'bg-gray-600' : 'bg-transparent'}`}
                title={isVolumeOff ? "Turn Volume On" : "Turn Volume Off"}
            >
                <div className="transform scale-125">
                    <VolumeComponent size={24} />
                </div>
            </button>

            {/* 3. Capture (Screenshot) Button */}
            <button
                onClick={handleTakeScreenshot}
                className="text-white hover:opacity-80 transition-all active:scale-95 drop-shadow-lg p-3 rounded-full bg-blue-500 hover:bg-blue-600"
                title="Take Screenshot"
            >
                <div className="transform scale-125">
                    <CameraIcon size={24} />
                </div>
            </button>

            {/* 4. End Call Button */}
            <button
                onClick={endCall}
                className="bg-red-600 text-white px-6 py-3 rounded-full hover:bg-red-700 transition-colors shadow-lg flex items-center gap-2 active:scale-[0.98]"
            >
                <div className="scale-100">
                    <PhoneOffIcon size={24} /> {/* SVG Icon */}
                </div>
                <span className="text-xl font-semibold">End Call</span>
            </button>
        </div>
    );
};

export default RemoteCallControls;